import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-problem-stop",
  "use": "foquz-icon-problem-stop-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-problem-stop\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 7A7 7 0 110 7a7 7 0 0114 0zM4 6a1 1 0 000 2h6a1 1 0 100-2H4z\" fill=\"#F96261\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol